// extracted by mini-css-extract-plugin
export default {"details-panel":"details-panel--yYAn0"};